(ns common.kpis)

; tenant-specific-visibilities are defined in frontend.utils
(defonce
 kpis
 [{:kw :kpi-kw/revenue :type :quantitative :visible? true}
  {:kw :kpi-kw/earnings :type :quantitative :visible? true}
  {:kw :kpi-kw/gross-revenue :type :quantitative :visible? true}
  {:kw :kpi-kw/net-revenue :type :quantitative :visible? true}
  {:kw :kpi-kw/net-earnings :type :quantitative :visible? true}
  {:kw :kpi-kw/cash-revenue :type :quantitative :visible? true}
  {:kw :kpi-kw/Cogs :type :quantitative :visible? true}
  {:kw :kpi-kw/gross-margin :type :quantitative :visible? true}
  {:kw :kpi-kw/SM-costs :type :quantitative :visible? true}
  {:kw :kpi-kw/RD-costs :type :quantitative :visible? true}
  {:kw :kpi-kw/admin-costs :type :quantitative :visible? true}
  {:kw :kpi-kw/cash-spend :type :quantitative :visible? true}
  {:kw :kpi-kw/ebitda :type :quantitative :visible? true}
  {:kw :kpi-kw/ebit :type :quantitative :visible? true}
  {:kw :kpi-kw/net-income :type :quantitative :visible? true}
  {:kw :kpi-kw/net-profit :type :quantitative :visible? true}
  {:kw :kpi-kw/non-current-assets :type :quantitative :visible? true}
  {:kw :kpi-kw/intangible-assets :type :quantitative :visible? true}
  {:kw :kpi-kw/current-assets :type :quantitative :visible? true}
  {:kw :kpi-kw/accounts-receivable :type :quantitative :visible? true}
  {:kw :kpi-kw/long-term-liabilities :type :quantitative :visible? true}
  {:kw :kpi-kw/current-liabilities :type :quantitative :visible? true}
  {:kw :kpi-kw/accounts-payable :type :quantitative :visible? true}
  {:kw :kpi-kw/equity :type :quantitative :visible? true}
  {:kw :kpi-kw/debt :type :quantitative :visible? true}
  {:kw :kpi-kw/total-assets :type :quantitative :visible? true}
  {:kw :kpi-kw/total-liabilities :type :quantitative :visible? true}
  {:kw :kpi-kw/nav :type :quantitative :visible? true}
  {:kw :kpi-kw/current-ratio :type :quantitative :visible? true}
  {:kw :kpi-kw/quick-ratio :type :quantitative :visible? true}
  {:kw :kpi-kw/working-capital :type :quantitative :visible? true}
  {:kw :kpi-kw/debt-to-equity :type :quantitative :visible? true}
  {:kw :kpi-kw/financial-leverage :type :quantitative :visible? true}
  {:kw :kpi-kw/cash-begin :type :quantitative :visible? true}
  {:kw :kpi-kw/cash-end :type :quantitative :visible? true}
  {:kw :kpi-kw/cash :type :quantitative :visible? true}
  {:kw :kpi-kw/cash-burn :type :quantitative :visible? true}
  {:kw :kpi-kw/cash-net-burn :type :quantitative :visible? true}
  {:kw :kpi-kw/cash-burn-next-month :type :quantitative :visible? true}
  {:kw :kpi-kw/ocf :type :quantitative :visible? true}
  {:kw :kpi-kw/fcf :type :quantitative :visible? true}
  {:kw :kpi-kw/runway-in-days :type :quantitative :visible? true}
  {:kw :kpi-kw/gross-runway-in-days :type :quantitative :visible? true}
  {:kw :kpi-kw/net-runway-in-days :type :quantitative :visible? true}
  {:kw :kpi-kw/SM-headcount :type :quantitative :visible? true}
  {:kw :kpi-kw/RD-headcount :type :quantitative :visible? true}
  {:kw :kpi-kw/admin-headcount :type :quantitative :visible? true}
  {:kw :kpi-kw/headcount :type :quantitative :visible? true}
  {:kw :kpi-kw/paying-customers :type :quantitative :visible? true}
  {:kw :kpi-kw/vacancy-rate :type :quantitative :visible? true}
  {:kw :kpi-kw/bookings :type :quantitative :visible? true}
  {:kw :kpi-kw/trials :type :quantitative :visible? true}
  {:kw :kpi-kw/demos :type :quantitative :visible? true}
  {:kw :kpi-kw/trial-to-demo :type :quantitative :visible? true}
  {:kw :kpi-kw/demo-to-paying :type :quantitative :visible? true}
  {:kw :kpi-kw/cac :type :quantitative :visible? true}
  {:kw :kpi-kw/ltv :type :quantitative :visible? true}
  {:kw :kpi-kw/arr :type :quantitative :visible? true}
  {:kw :kpi-kw/mrr :type :quantitative :visible? true}
  {:kw :kpi-kw/dac :type :quantitative :visible? true}
  {:kw :kpi-kw/dau :type :quantitative :visible? true}
  {:kw :kpi-kw/wau :type :quantitative :visible? true}
  {:kw :kpi-kw/mau :type :quantitative :visible? true}
  {:kw :kpi-kw/MRR-churn :type :quantitative :visible? true}
  {:kw :kpi-kw/ARR-churn :type :quantitative :visible? true}
  {:kw :kpi-kw/churn :type :quantitative :visible? true}
  {:kw :kpi-kw/arpa :type :quantitative :visible? true}
  {:kw :kpi-kw/arpu :type :quantitative :visible? true}
  {:kw :kpi-kw/account-receivable :type :quantitative :visible? true}
  {:kw :kpi-kw/total-current-assets :type :quantitative :visible? true}
  {:kw :kpi-kw/account-payable :type :quantitative :visible? true}
  {:kw :kpi-kw/total-current-liabilities :type :quantitative :visible? true}
  {:kw :kpi-kw/net-current-assets-and-liabilities :type :quantitative :visible? true}
  {:kw :kpi-kw/total-equity :type :quantitative :visible? true}
  {:kw :kpi-kw/cost-of-sales :type :quantitative :visible? true}
  {:kw :kpi-kw/gross-profit :type :quantitative :visible? true}
  {:kw :kpi-kw/marketing-expenses :type :quantitative :visible? true}
  {:kw :kpi-kw/total-employee-benefits :type :quantitative :visible? true}
  {:kw :kpi-kw/total-operating-expenses :type :quantitative :visible? true}
  {:kw :kpi-kw/percentage-of-non-performing-loans :type :quantitative :visible? true}
  {:kw :kpi-kw/average-amount-raised :type :quantitative :visible? true}
  {:kw :kpi-kw/average-basket-size :type :quantitative :visible? true}
  {:kw :kpi-kw/average-order-value :type :quantitative :visible? true}
  {:kw :kpi-kw/average-revenue-per-media-client :type :quantitative :visible? true}
  {:kw :kpi-kw/cryptocurrency-value :type :quantitative :visible? true}
  {:kw :kpi-kw/downloads :type :quantitative :visible? true}
  {:kw :kpi-kw/influencers-reach :type :quantitative :visible? true}
  {:kw :kpi-kw/monthly-active-corporate-user-brands :type :quantitative :visible? true}
  {:kw :kpi-kw/monthly-active-users-last-login :type :quantitative :visible? true}
  {:kw :kpi-kw/monthly-active-youth-user-events-organizers :type :quantitative :visible? true}
  {:kw :kpi-kw/monthly-returning-unique-visitors :type :quantitative :visible? true}
  {:kw :kpi-kw/monthly-unique-visitors :type :quantitative :visible? true}
  {:kw :kpi-kw/new-first-time-client-added-value :type :quantitative :visible? true}
  {:kw :kpi-kw/new-first-time-clients-dded :type :quantitative :visible? true}
  {:kw :kpi-kw/new-investors-added :type :quantitative :visible? true}
  {:kw :kpi-kw/new-registered-members :type :quantitative :visible? true}
  {:kw :kpi-kw/new-registered-users :type :quantitative :visible? true}
  {:kw :kpi-kw/no-of-media-clients :type :quantitative :visible? true}
  {:kw :kpi-kw/no-of-media-clients-in-pipeline :type :quantitative :visible? true}
  {:kw :kpi-kw/no-of-orders :type :quantitative :visible? true}
  {:kw :kpi-kw/no-of-selling-listings :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-acquisition :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-active-clients :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-active-restaurants :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-influencers-accumulated :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-apps-in-catappult :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-campaigns :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-clients-in-pipeline :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-completed-loans :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-customers :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-delivery :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-disbursed-loans :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-full-time-agents :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-investments :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-live-skus :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-loans-in-pipeline :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-media-deals :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-onboarded-restaurants :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-part-time-agents :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-suppliers :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-transactions :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-verification :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-youths-complete-and-created-profile :type :quantitative :visible? true}
  {:kw :kpi-kw/page-views :type :quantitative :visible? true}
  {:kw :kpi-kw/page-visits :type :quantitative :visible? true}
  {:kw :kpi-kw/rate-of-active-restaurants :type :quantitative :visible? true}
  {:kw :kpi-kw/recurring-rate-sales :type :quantitative :visible? true}
  {:kw :kpi-kw/registered-users :type :quantitative :visible? true}
  {:kw :kpi-kw/request-for-quotation-gmv :type :quantitative :visible? true}
  {:kw :kpi-kw/runway :type :quantitative :visible? true}
  {:kw :kpi-kw/total-amount-of-investment :type :quantitative :visible? true}
  {:kw :kpi-kw/total-amount-raised :type :quantitative :visible? true}
  {:kw :kpi-kw/total-contributors :type :quantitative :visible? true}
  {:kw :kpi-kw/total-investors :type :quantitative :visible? true}
  {:kw :kpi-kw/total-number-of-clients :type :quantitative :visible? true}
  {:kw :kpi-kw/total-number-of-listings :type :quantitative :visible? true}
  {:kw :kpi-kw/total-number-of-sellers-or-suppliers :type :quantitative :visible? true}
  {:kw :kpi-kw/total-number-of-selling-listings :type :quantitative :visible? true}
  {:kw :kpi-kw/total-number-of-transactions :type :quantitative :visible? true}
  {:kw :kpi-kw/total-registered-members :type :quantitative :visible? true}
  {:kw :kpi-kw/total-registered-users :type :quantitative :visible? true}
  {:kw :kpi-kw/trial-conversion :type :quantitative :visible? true}
  {:kw :kpi-kw/trials-ongoing :type :quantitative :visible? true}
  {:kw :kpi-kw/unique-visitors :type :quantitative :visible? true}
  {:kw :kpi-kw/value-of-loans-raised :type :quantitative :visible? true}
  {:kw :kpi-kw/valuation-by-pwc :type :quantitative :visible? true}
  {:kw :kpi-kw/unit-economics-kpi :type :quantitative :visible? true}
  {:kw :kpi-kw/hiring-need-for-next-6m :type :quantitative :visible? true}
  {:kw :kpi-kw/gross-transaction-value :type :quantitative :visible? true}
  {:kw :kpi-kw/take-rate :type :quantitative :visible? true}
  {:kw :kpi-kw/user-retention :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-transactions-individuals :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-transactions-group :type :quantitative :visible? true}
  {:kw :kpi-kw/user-transaction-frequency :type :quantitative :visible? true}
  {:kw :kpi-kw/customer-ltv-cac :type :quantitative :visible? true}
  {:kw :kpi-kw/total-amount-of-deposits-individual :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-savings-groups-created :type :quantitative :visible? true}
  {:kw :kpi-kw/net-individual-savers :type :quantitative :visible? true}
  {:kw :kpi-kw/net-savings-groups :type :quantitative :visible? true}
  {:kw :kpi-kw/total-amount-of-deposits-group :type :quantitative :visible? true}
  {:kw :kpi-kw/monthly-revenue :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-partnerships-closed :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-inbound-requests :type :quantitative :visible? true}
  {:kw :kpi-kw/lead-conversion-rate :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-people-reached :type :quantitative :visible? true}
  {:kw :kpi-kw/average-number-of-transactions-per-customer :type :quantitative :visible? true}
  {:kw :kpi-kw/app-adoption-rate :type :quantitative :visible? true}
  {:kw :kpi-kw/total-amount-raised-monthly :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-property-developer-sign-ups :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-subscribers-individual :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-consultations :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-medical-practitioners :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-subscribers-facility :type :quantitative :visible? true}
  {:kw :kpi-kw/monthly-job-placements :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-verified-developers :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-developers-tested :type :quantitative :visible? true}
  {:kw :kpi-kw/platform-conversion-rate :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-onboarded-distributors :type :quantitative :visible? true}
  {:kw :kpi-kw/amount-made-per-transaction-for-producer :type :quantitative :visible? true}
  {:kw :kpi-kw/amount-saved-per-transaction-for-consumer :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-specialists-active-on-platform :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-stores-in-partnership :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-paid-consultations :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-on-boarded-salon-owners :type :quantitative :visible? true}
  {:kw       :kpi-kw/number-of-on-boarded-freelance-beauty-professionals
   :type     :quantitative
   :visible? true}
  {:kw :kpi-kw/expected-monthly-payback :type :quantitative :visible? true}
  {:kw :kpi-kw/recovered-monthly-payback :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-companies-onboarded :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-articles-read :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-app-visits :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-community-members :type :quantitative :visible? true}
  {:kw :kpi-kw/event-conversion-rate :type :quantitative :visible? true}
  {:kw :kpi-kw/weekly-active-users-last-login :type :quantitative :visible? true}
  {:kw :kpi-kw/posts-per-user-logged-in :type :quantitative :visible? true}
  {:kw :kpi-kw/total-amount-requested :type :quantitative :visible? true}
  {:kw :kpi-kw/estimated-number-of-customers :type :quantitative :visible? true}
  {:kw :kpi-kw/signed-up-smes :type :quantitative :visible? true}
  {:kw :kpi-kw/onboarded-smes :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-new-buyers :type :quantitative :visible? true}
  {:kw :kpi-kw/value-of-receivables-submitted :type :quantitative :visible? true}
  {:kw :kpi-kw/value-of-financed-invoices :type :quantitative :visible? true}
  {:kw :kpi-kw/value-of-loan-disbursed :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-new-financiers-onboarded :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-repeat-financiers :type :quantitative :visible? true}
  {:kw :kpi-kw/interest-returns-for-the-month :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-pickups :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-completed-pick-ups :type :quantitative :visible? true}
  {:kw :kpi-kw/studios-onboarded :type :quantitative :visible? true}
  {:kw :kpi-kw/artists-onboarded :type :quantitative :visible? true}
  {:kw :kpi-kw/producers-onboarded :type :quantitative :visible? true}
  {:kw :kpi-kw/milestone-1-amount :type :quantitative :visible? true}
  {:kw :kpi-kw/milestone-2-amount :type :quantitative :visible? true}
  {:kw :kpi-kw/milestone-3-amount :type :quantitative :visible? true}
  {:kw :kpi-kw/milestone-4-amount :type :quantitative :visible? true}
  {:kw :kpi-kw/milestone-5-amount :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-new-wallet-provider-onboarded :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-new-merchants-onboarded :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-wallet-provider-churn :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-merchant-churn :type :quantitative :visible? true}
  {:kw       :kpi-kw/average-number-of-transactions-from-each-wallet-provider
   :type     :quantitative
   :visible? true}
  {:kw :kpi-kw/average-number-of-transactions-from-each-merchant :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-demo-requests :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-sign-ups :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-podcast-listeners :type :quantitative :visible? true}
  {:kw :kpi-kw/demo-conversion-rate :type :quantitative :visible? true}
  {:kw :kpi-kw/podcast-conversion-rate :type :quantitative :visible? true}
  {:kw :kpi-kw/social-media-followers :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-informal-retailers-onboarded :type :quantitative :visible? true}
  {:kw :kpi-kw/total-amount-of-orders-received :type :quantitative :visible? true}
  {:kw :kpi-kw/total-amount-of-orders-fulfilled :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-areas-covered :type :quantitative :visible? true}
  {:kw :kpi-kw/amount-of-orders-fulfilled-received-ratio :type :quantitative :visible? true}
  {:kw :kpi-kw/average-total-transactions-per-customer :type :quantitative :visible? true}
  {:kw :kpi-kw/average-total-orders-per-customer :type :quantitative :visible? true}
  {:kw :kpi-kw/retailers-field-agents-ratio :type :quantitative :visible? true}
  {:kw :kpi-kw/android-downloads :type :quantitative :visible? true}
  {:kw :kpi-kw/app-store-downloads :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-resellers-onboarded :type :quantitative :visible? true}
  {:kw :kpi-kw/social-media-following :type :quantitative :visible? true}
  {:kw :kpi-kw/referral-rates :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-suppliers-onboarded :type :quantitative :visible? true}
  {:kw :kpi-kw/total-amount-paid-to-delivery-partners :type :quantitative :visible? true}
  {:kw :kpi-kw/customer-satisfaction-rate :type :quantitative :visible? true}
  {:kw :kpi-kw/transporter-satisfaction-rate :type :quantitative :visible? true}
  {:kw :kpi-kw/total-number-of-delivery-partners :type :quantitative :visible? true}
  {:kw :kpi-kw/co2-emissions :type :quantitative :visible? true}
  {:kw :kpi-kw/hfc-emissions :type :quantitative :visible? true}
  {:kw :kpi-kw/voc-emissions :type :quantitative :visible? true}
  {:kw :kpi-kw/co2-footprint :type :quantitative :visible? true}
  {:kw :kpi-kw/hazardous-waste-created :type :quantitative :visible? true}
  {:kw :kpi-kw/waste-sent-to-landfills :type :quantitative :visible? true}
  {:kw :kpi-kw/total-paper-consumed :type :quantitative :visible? true}
  {:kw :kpi-kw/clean-water-consumption :type :quantitative :visible? true}
  {:kw :kpi-kw/renewal-energy-ratio :type :quantitative :visible? true}
  {:kw :kpi-kw/total-annual-energy-consumption :type :quantitative :visible? true}
  {:kw :kpi-kw/new-jobs-created :type :quantitative :visible? true}
  {:kw :kpi-kw/full-time-employees :type :quantitative :visible? true}
  {:kw :kpi-kw/employee-diversity-index :type :quantitative :visible? true}
  {:kw :kpi-kw/paying-customers-b2b :type :quantitative :visible? true}
  {:kw :kpi-kw/paying-customers-b2c :type :quantitative :visible? true}
  {:kw :kpi-kw/churn-rate-b2b :type :quantitative :visible? true}
  {:kw :kpi-kw/retention-b2b :type :quantitative :visible? true}
  {:kw :kpi-kw/nps-score :type :quantitative :visible? true}
  {:kw :kpi-kw/monthly-amount-of-online-payments-processed :type :quantitative :visible? true}
  {:kw :kpi-kw/monthly-number-of-online-payments :type :quantitative :visible? true}
  {:kw :kpi-kw/total-number-of-monthly-transactions :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-active-acres :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-farmers-on-marketplace :type :quantitative :visible? true}
  {:kw :kpi-kw/ebitda-margin :type :quantitative :visible? true}
  {:kw :kpi-kw/operational-efficiency :type :quantitative :visible? true}
  {:kw :kpi-kw/revenue-from-products-and-services :type :quantitative :visible? true}
  {:kw :kpi-kw/revenue-from-nre :type :quantitative :visible? true}
  {:kw :kpi-kw/grants-received :type :quantitative :visible? true}

  {:kw :kpi-kw/sales-actual :type :quantitative :visible? true}
  {:kw :kpi-kw/sales-budget :type :quantitative :visible? true}
  {:kw :kpi-kw/gross-margin-percentage-actual :type :quantitative :visible? true}
  {:kw :kpi-kw/gross-margin-percentage-budget :type :quantitative :visible? true}
  {:kw :kpi-kw/ebitda-ex-non-recurring-items-actual :type :quantitative :visible? true}
  {:kw :kpi-kw/ebitda-ex-non-recurring-items-budget :type :quantitative :visible? true}
  {:kw :kpi-kw/ebita-ex-non-recurring-items-actual :type :quantitative :visible? true}
  {:kw :kpi-kw/ebita-ex-non-recurring-items-budget :type :quantitative :visible? true}
  {:kw :kpi-kw/ebit-ex-non-recurring-items-actual :type :quantitative :visible? true}
  {:kw :kpi-kw/ebit-ex-non-recurring-items-budget :type :quantitative :visible? true}
  {:kw :kpi-kw/non-recurring-items :type :quantitative :visible? true}
  {:kw :kpi-kw/net-profit-actual :type :quantitative :visible? true}
  {:kw :kpi-kw/net-profit-budget :type :quantitative :visible? true}
  {:kw :kpi-kw/net-debt :type :quantitative :visible? true}
  {:kw :kpi-kw/equity-ratio :type :quantitative :visible? true}
  {:kw :kpi-kw/cash-flow-from-operative-activities :type :quantitative :visible? true}
  {:kw :kpi-kw/cash-flow-from-investing-activities :type :quantitative :visible? true}
  {:kw :kpi-kw/cash-flow-from-financing-activities :type :quantitative :visible? true}
  {:kw :kpi-kw/cash-at-beginning-of-period :type :quantitative :visible? true}
  {:kw :kpi-kw/cash-at-end-of-period :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-full-time-employees :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-freelancers-and-subcontractors :type :quantitative :visible? true}
  {:kw :kpi-kw/interest-bearing-debt :type :quantitative :visible? true}
  {:kw :kpi-kw/ebitda-actual :type :quantitative :visible? true}
  {:kw :kpi-kw/ebitda-budget :type :quantitative :visible? true}
  {:kw :kpi-kw/ebita-actual :type :quantitative :visible? true}
  {:kw :kpi-kw/ebita-budget :type :quantitative :visible? true}
  {:kw :kpi-kw/ebit-actual :type :quantitative :visible? true}
  {:kw :kpi-kw/ebit-budget :type :quantitative :visible? true}
  {:kw :kpi-kw/revenue-akokomarket :type :quantitative :visible? true}
  {:kw :kpi-kw/profit-akokomarket :type :quantitative :visible? true}
  {:kw :kpi-kw/revenue-akokotakra :type :quantitative :visible? true}
  {:kw :kpi-kw/profit-akokotakra :type :quantitative :visible? true}
  {:kw :kpi-kw/revenue-fbs-innova :type :quantitative :visible? true}
  {:kw :kpi-kw/profit-fbs-innova :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-crates-sold-per-month :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-chicken-sold-per-month :type :quantitative :visible? true}
  {:kw :kpi-kw/tons-of-maize-sold-per-month :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-new-customers-per-month :type :quantitative :visible? true}
  {:kw :kpi-kw/total-number-of-active-customers :type :quantitative :visible? true}
  {:kw :kpi-kw/total-number-of-subscriptions :type :quantitative :visible? true}
  {:kw :kpi-kw/total-number-of-paying-customers :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-projects-onboarded :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-active-users :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-company-accounts :type :quantitative :visible? true}
  {:kw :kpi-kw/monthly-revenue-growth-rate :type :quantitative :visible? true}
  {:kw :kpi-kw/monthly-active-customers-users :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-new-customers-acquired :type :quantitative :visible? true}
  {:kw :kpi-kw/transaction-volume :type :quantitative :visible? true}
  {:kw :kpi-kw/transaction-value :type :quantitative :visible? true}
  {:kw :kpi-kw/payments-service-revenue :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-active-churches :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-paying-churches :type :quantitative :visible? true}
  {:kw :kpi-kw/crm-revenue :type :quantitative :visible? true}
  {:kw :kpi-kw/transaction-value-processed :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-retail-merchants-active :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-new-merchants-signed-up :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-new-integrations :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-paying-agencies :type :quantitative :visible? true}
  {:kw :kpi-kw/total-number-of-agencies :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-developers :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-paying-developers :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-independent-agents :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-new-listings :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-active-listings :type :quantitative :visible? true}
  {:kw :kpi-kw/total-listings :type :quantitative :visible? true}
  {:kw :kpi-kw/agencies :type :quantitative :visible? true}
  {:kw :kpi-kw/revenue-actual :type :quantitative :visible? true}
  {:kw :kpi-kw/revenue-planned :type :quantitative :visible? true}
  {:kw :kpi-kw/cogs-actual :type :quantitative :visible? true}
  {:kw :kpi-kw/cogs-planned :type :quantitative :visible? true}
  {:kw :kpi-kw/personnel-costs-actual :type :quantitative :visible? true}
  {:kw :kpi-kw/personnel-costs-planned :type :quantitative :visible? true}
  {:kw :kpi-kw/other-expenses-actual :type :quantitative :visible? true}
  {:kw :kpi-kw/other-expenses-planned :type :quantitative :visible? true}
  {:kw :kpi-kw/ebitda-planned :type :quantitative :visible? true}
  {:kw :kpi-kw/ebitd-actual :type :quantitative :visible? true}
  {:kw :kpi-kw/ebitd-planned :type :quantitative :visible? true}
  {:kw :kpi-kw/cash-actual :type :quantitative :visible? true}
  {:kw :kpi-kw/cash-planned :type :quantitative :visible? true}
  {:kw :kpi-kw/contracted-machines :type :quantitative :visible? true}
  {:kw :kpi-kw/onboarded-machines :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-partnerships :type :quantitative :visible? true}
  {:kw :kpi-kw/opportunities-to-deals :type :quantitative :visible? true}
  {:kw :kpi-kw/opportunity-retention-rate :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-dashboard-shared :type :quantitative :visible? true}
  {:kw :kpi-kw/customer-churn-rate :type :quantitative :visible? true}
  {:kw :kpi-kw/average-lifetime-value :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-merchants :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-product-item-count :type :quantitative :visible? true}
  {:kw :kpi-kw/cross-transaction-value-storefront :type :quantitative :visible? true}
  {:kw :kpi-kw/gross-transaction-volume :type :quantitative :visible? true}
  {:kw :kpi-kw/value-of-transactions-processor :type :quantitative :visible? true}
  {:kw :kpi-kw/volume-of-transactions-processor :type :quantitative :visible? true}
  {:kw :kpi-kw/revenues-per-subscription :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-content-plays :type :quantitative :visible? true}
  {:kw :kpi-kw/new-vehicles-onboarded-monthly :type :quantitative :visible? true}
  {:kw :kpi-kw/average-number-of-new-users-added-monthly :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-trips-completed-monthly :type :quantitative :visible? true}
  {:kw :kpi-kw/average-session-time-on-app :type :quantitative :visible? true}
  {:kw       :kpi-kw/pct-of-new-active-members-added-by-referrals-monthly
   :type     :quantitative
   :visible? true}
  {:kw :kpi-kw/number-of-articles-or-copies-created-monthly :type :quantitative :visible? true}
  {:kw :kpi-kw/average-user-rating :type :quantitative :visible? true}
  {:kw :kpi-kw/average-merchants-users-added-monthly :type :quantitative :visible? true}
  {:kw :kpi-kw/average-session-time :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-merchant-activation-monthly :type :quantitative :visible? true}
  {:kw :kpi-kw/average-website-users-added-monthly :type :quantitative :visible? true}
  {:kw :kpi-kw/pct-of-new-community-members-added-monthly :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-new-articles-vs-videos-released-monthly :type :quantitative :visible? true}
  {:kw :kpi-kw/community-churn-rate :type :quantitative :visible? true}
  {:kw :kpi-kw/average-session-time-on-blog :type :quantitative :visible? true}
  {:kw :kpi-kw/average-session-time-on-lessons :type :quantitative :visible? true}
  {:kw :kpi-kw/average-user-rating-on-website-content :type :quantitative :visible? true}

  {:kw   :kpi-kw/inventory
   :type :quantitative
   :tenant-specific-visibility? true}

  {:kw :kpi-kw/number-of-active-hospitals :type :quantitative :visible? true}
  {:kw :kpi-kw/monthly-recurring-orders :type :quantitative :visible? true}
  {:kw :kpi-kw/customer-retention-rate :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-onboarded-manufacturers :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-onboarded-hospitals :type :quantitative :visible? true}
  {:kw :kpi-kw/average-order-fulfillment-time :type :quantitative :visible? true}
  {:kw :kpi-kw/customer-conversion-rate :type :quantitative :visible? true}
  {:kw :kpi-kw/percentage-of-order-processed :type :quantitative :visible? true}
  {:kw :kpi-kw/mom-retention :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-active-boosters :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-paying-brands :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-missions-onboarded :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-missions-completed :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-missions-completed-per-brand :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-interactions :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-impressions :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-sales :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-active-customers :type :quantitative :visible? true}
  {:kw :kpi-kw/monthly-returning-users :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-agents-onboarded :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-ad-campaigns :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-paid-assets :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-quests-generated :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-responses-collected :type :quantitative :visible? true}
  {:kw :kpi-kw/duration-of-audio-responses-gathered :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-conversational-analysis-prompts :type :quantitative :visible? true}
  {:kw :kpi-kw/number-of-monthly-active-users :type :quantitative :visible? true}
  {:kw :kpi-kw/revenue-generated :type :quantitative :visible? true}

  ;; leave next 2 as last
  {:kw :kpi-kw/key-result1 :type :quantitative :visible? true :skip-sort? true} ; Key activity 1
  {:kw :kpi-kw/key-result2 :type :quantitative :visible? true :skip-sort? true} ; Key activity 2
  {:kw :kpi-kw/key-result3 :type :quantitative :visible? true :skip-sort? true} ; Key activity 2
  {:kw :kpi-kw/key-result4 :type :quantitative :visible? true :skip-sort? true} ; Key activity 2
 ])


(defonce
 questions
 [{:kw :kpi-q-kw/recent-developments :type :qualitative :visible? true}
  {:kw :kpi-q-kw/current-challenges :type :qualitative :visible? true}
  {:kw :kpi-q-kw/must-win-battles :type :qualitative :visible? true}
  {:kw :kpi-q-kw/deviation-from-plan :type :qualitative :visible? true}
  {:kw :kpi-q-kw/fundraising-status :type :qualitative :visible? true}
  {:kw :kpi-q-kw/net-cash-end-date :type :qualitative :visible? true}
  {:kw :kpi-q-kw/gross-cash-end-date :type :qualitative :visible? true}
  {:kw :kpi-q-kw/value-proposition :type :qualitative :visible? true}
  {:kw :kpi-q-kw/major-achievements :type :qualitative :visible? true}
  {:kw :kpi-q-kw/major-disappointments :type :qualitative :visible? true}
  {:kw :kpi-q-kw/new-customer-insight :type :qualitative :visible? true}
  {:kw :kpi-q-kw/help-wanted :type :qualitative :visible? true}
  {:kw :kpi-q-kw/general-update :type :qualitative :visible? true}
  {:kw :kpi-q-kw/ceo-comment :type :qualitative :visible? true}
  {:kw :kpi-q-kw/cfo-comment :type :qualitative :visible? true}
  {:kw :kpi-q-kw/runway-until-gross :type :qualitative :visible? true}
  {:kw :kpi-q-kw/runway-until-net :type :qualitative :visible? true}
  {:kw :kpi-q-kw/exit-driven-actions :type :qualitative :visible? true}
  {:kw :kpi-q-kw/company-why :type :qualitative :visible? true}
  {:kw :kpi-q-kw/company-how :type :qualitative :visible? true}
  {:kw :kpi-q-kw/company-what :type :qualitative :visible? true}
  {:kw :kpi-q-kw/stage :type :qualitative :visible? true}
  {:kw :kpi-q-kw/objectives-6-months :type :qualitative :visible? true}
  {:kw :kpi-q-kw/unit-economics-kpi :type :qualitative :visible? true}
  {:kw :kpi-q-kw/profiles-of-planned-new-recruits :type :qualitative :visible? true}
  {:kw :kpi-q-kw/current-bottlenecks :type :qualitative :visible? true}
  {:kw :kpi-q-kw/objectives-for-next-month :type :qualitative :visible? true}

  {:kw :kpi-q-kw/feedback-on-mentor-support-network :type :qualitative :visible? true}
  {:kw :kpi-q-kw/milestones-set :type :qualitative :visible? true}
  {:kw :kpi-q-kw/milestones-achieved :type :qualitative :visible? true}
  {:kw :kpi-q-kw/milestone-1 :type :qualitative :visible? true}
  {:kw :kpi-q-kw/milestone-2 :type :qualitative :visible? true}
  {:kw :kpi-q-kw/milestone-3 :type :qualitative :visible? true}
  {:kw :kpi-q-kw/milestone-4 :type :qualitative :visible? true}
  {:kw :kpi-q-kw/milestone-5 :type :qualitative :visible? true}
  {:kw :kpi-q-kw/top-3-kpis-for-the-quarter :type :qualitative :visible? true}
  {:kw :kpi-q-kw/monthly-expenses-summary :type :qualitative :visible? true}
  {:kw :kpi-q-kw/product-development-progress-update :type :qualitative :visible? true}
  {:kw :kpi-q-kw/actions-to-reduce-waste-last-12-months :type :qualitative :visible? true}
  {:kw       :kpi-q-kw/initiatives-for-contributing-to-local-communities
   :type     :qualitative
   :visible? true}
  {:kw :kpi-q-kw/ensure-equal-treatment-of-job-applicants :type :qualitative :visible? true}
  {:kw :kpi-q-kw/highlights :type :qualitative :visible? true}
  {:kw :kpi-q-kw/lowlights :type :qualitative :visible? true}
  {:kw :kpi-q-kw/outlook :type :qualitative :visible? true}

  {:kw   :kpi-q-kw/most-important-planned-hiring-next-6m
   :type :qualitative
   :tenant-specific-visibility? true}
  {:kw   :kpi-q-kw/unused-overdraft-facilities
   :type :qualitative
   :tenant-specific-visibility? true}
  {:kw   :kpi-q-kw/working-capital-finance-in-place
   :type :qualitative
   :tenant-specific-visibility? true}
  {:kw   :kpi-q-kw/loans-in-place
   :type :qualitative
   :tenant-specific-visibility? true}
  {:kw   :kpi-q-kw/new-equity-investors
   :type :qualitative
   :tenant-specific-visibility? true}
  {:kw   :kpi-q-kw/granted-securities-to-third-party
   :type :qualitative
   :tenant-specific-visibility? true}

  ;; leave next 2 as last
  {:kw :kpi-q-kw/key-result1-definition :type :qualitative :visible? true :skip-sort? true} ;; Key activity definition 1
  {:kw :kpi-q-kw/key-result2-definition :type :qualitative :visible? true :skip-sort? true} ;; Key activity definition 2
  {:kw :kpi-q-kw/key-result3-definition :type :qualitative :visible? true :skip-sort? true} ;; Key activity definition 1
  {:kw :kpi-q-kw/key-result4-definition :type :qualitative :visible? true :skip-sort? true}]) ;; Key activity definition 2



(def kpi-options
  (->> kpis
       (map (fn [{:keys [kw]}]
              {:key   kw
               :label (str "KPI - " kw)}))))

(def question-options
  (->> questions
       (map (fn [{:keys [kw]}]
              {:key   kw
               :label (str "Question - " kw)}))))
